// extracted by mini-css-extract-plugin
export default {"contentWrapper":"DividerContent_contentWrapper__kaz5T","divider":"DividerContent_divider__k75xc","content":"DividerContent_content__qtlvr"};